import script from "./UploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFile.vue?vue&type=script&setup=true&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=6afb5162&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6afb5162"]])

export default __exports__